export default __webpack_public_path__ + "static/media/logo_icon.c95147f8.svg";